import 'css-chunksrc/client/pages/zonesPage/wbsPage/exportButton/loader/styles.scss';export default {
  "loader": "_loader_1svq7_1",
  "spin": "_spin_1svq7_1"
};